module.exports = __webpack_public_path__ + "img/avatar2.1b8103c4.png";